'use client';

export default function PrivacyPage() {
  return (
    <iframe
      src="https://www.iubenda.com/privacy-policy/69421986"
      className="w-full h-svh min-h-svh border-none"
      title="Privacy Policy"
    />
  );

  /*
  redirect('https://www.iubenda.com/privacy-policy/69421986');
  */

  /*
  useSmoothScroll();

  return (
    <div className="min-h-screen overflow-x-hidden">
      <NavigationBar />
      <main className="flex min-h-screen flex-col pt-16 left-0 right-0">
        <LegalViewer htmlContent={privacyIt} />
        <Footer />
      </main>
    </div>
  );
  */
}
